import React, { useState } from "react";
import { sha256 } from "js-sha256";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(process.env.REACT_APP_BACKEND_URL + 'login', {
                method: "POST",
                headers: {
                    "Content-Type": "text/plain",
                },
                body: JSON.stringify({ username: username, password: sha256(password) }),
            });

            if (response.ok) {
                let data = await response.text();
                data = JSON.parse(data);
                if ( 'username' in data) {
                    localStorage.setItem("user", data.username);
                    localStorage.setItem("token", data.token);
                    window.location.href = "/";
                } else {
                    setError("Invalid username or password");
                }
            } else {
                setError("Invalid username or password");
            }
        } catch (error) {
            setError("An error occurred");
            console.error(error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="space-y-12 m-10">
                <div className="border-b border-gray-900/10 pb-12 justify-center">
                    <h2 className="text-base font-semibold leading-7 text-gray-900">Login</h2>
                    <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div className="sm:col-span-2"></div>
                        <div className="sm:col-span-2">
                            <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">Username</label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="username"
                                    id="username"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2"></div>

                        <div className="sm:col-span-2"></div>
                        <div className="sm:col-span-2">
                            <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">Password</label>
                            <div className="mt-2">
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {error && <div className="text-red-500">{error}</div>}

            <div className="mt-6 flex items-center justify-center gap-x-6">
                <button
                    type="submit"
                    className="rounded-md bg-gray-800 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-800"
                >
                    Login
                </button>
            </div>
        </form>
    );
}

export default Login;